import Image from "next/image";
import Link from "next/link";
import { formatDate } from "./blogHelpers";
import PlaceholderImage from "./PlaceholderImage";

// No author field exists on a post yet, so fall back to the brand.
const DEFAULT_AUTHOR = "Imagive Team";

const getInitials = (name) =>
  name
    .split(" ")
    .filter(Boolean)
    .map((word) => word[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();

export default function FeaturedBlog({ latestBlogPost }) {
  const author = latestBlogPost?.author || DEFAULT_AUTHOR;

  return (
    <Link
      href={`/blog/${latestBlogPost?.slug}`}
      className="group grid grid-cols-1 lg:grid-cols-[1.1fr_0.9fr]"
    >
      {/* Text */}
      <div className="flex flex-col px-6 lg:px-10 py-4 lg:py-6">
        <p className="font-mono text-xs uppercase tracking-widest text-[#999591] mb-8">
          {formatDate(latestBlogPost?.created_at)}{" "}
          <span className="text-[#999591] text-lg ">•</span>
        </p>

        <h2 className=" leading-[1.3] text-[28px] sm:text-[36px] lg:text-[40px]  xl:text-[46px] 2xl:text-[52px] 3xl:text-[60px] font-[550] tracking-tight bg-clip-text text-transparent bg-gradient-to-r from-[#0B0B0B] to-[#717171]  group-hover:text-gray-700 transition-colors">
          {latestBlogPost?.title}
        </h2>

        {/* Author byline */}
        <div className="flex items-center gap-3 mt-10">
          <span className="grid place-items-center w-12 h-8 rounded-full border border-[#CCC9C2] text-[12px] font-semibold text-[#555350] ">
            {getInitials(author)}
          </span>
          <span className="text-[12px] font-medium tracking-wide text-[#999591] ">
            BY
          </span>
          <span className="text-[12px] font-bold tracking-wide uppercase text-[#555350] ">
            {author}
          </span>
        </div>
      </div>

      {/* Image */}
      <div className="order-first lg:order-last flex items-center md:border-l border-gray-200 px-10 ">
        {latestBlogPost?.image ? (
          <Image
            src={latestBlogPost.image}
            alt={latestBlogPost.title}
            title={latestBlogPost.title}
            width={620}
            height={420}
            loading="lazy"
            className="w-full h-auto object-contain aspect-[3/2]"
          />
        ) : (
          <PlaceholderImage />
        )}
      </div>
    </Link>
  );
}
